import React from 'react';

import { FormContainerProps } from '@occc-app/offerHelpers/types';
import { useGetConfigureFormProps } from '@occc-app/offerHelpers/hooks/useGetConfigureFormProps';
import { useRedirectOnCampaignChange } from '@occc-app/offerHelpers/hooks/useRedirectOnCampaignChange';

import { PunchcardConfigureForm } from './PunchcardConfigureForm';
import { transformOfferToInitialValues } from './utils/configureFormInitialValues';
import { getConfigureFormOperations } from './utils/configureFormOperations';

import { PunchcardConfigureFormInitialValues, PunchcardConfigureFormValues } from '../../types';

export const PunchcardConfigureFormContainer: React.FC<FormContainerProps> = (props) => {
  const handleSubmitSuccess = useRedirectOnCampaignChange(props);

  const configureProps = useGetConfigureFormProps<
    PunchcardConfigureFormValues,
    PunchcardConfigureFormInitialValues
  >(props, transformOfferToInitialValues, getConfigureFormOperations, {
    onSubmitSuccess: handleSubmitSuccess,
  });

  return <PunchcardConfigureForm {...configureProps} />;
};
